export default __webpack_public_path__ + "static/media/ic_floki_24.70094103.png";